// extracted by mini-css-extract-plugin
export default {"wizard":"style_wizard__Pvpgb","option":"style_option__u+H7j","number":"style_number__+Nm1M","label":"style_label__pOEHC"};